export default {
  error: '错误',
  close: '关闭',

  downloadApp: '下载 App',

  loadTextFile: '载入文字字幕',
  lines: '字幕行数：{n} 行',
  startEditing: '开始编辑',
  reactTime: '反应时间：',
  currentLine: '当前字幕',
  emptyHint: '[空]',
  comingLines: '字幕预览',
  eofHint: '[文件结束]',
  startReviewing: '开始审阅',
  updatePreview: '更新预览',
  saveSrt: '保存为 SRT 文件',
  saveVtt: '保存为 WebVTT 文件',
  loadVideo: '载入视频',

  emptySubtitle: '字幕不能为空',
  invalidSrt: 'SRT 文件不合法',

  shortcuts: '操作',
  shortcutK: '切换至下一行',
  shortcutL: '停止当前行',
  shortcutU: '后退 3 秒',
  shortcutP: '快进 3 秒',
  shortcutI: '返回上一行',
  shortcutO: '跳过当前行',
  shortcutR: '暂停 / 播放',
  shortcutQ: '减速播放',
  shortcutE: '加速播放',
};



// WEBPACK FOOTER //
// ./src/i18n/zh-cn.js